/**
 * AI Settings - English Localization
 */

export default {
    aiSettings: {
        title: 'AI Settings',
        description: 'Configure how AI responds to your requests',
        loading: 'Loading settings...',
        saving: 'Saving...',
        saveSuccess: 'Settings saved successfully',
        saveError: 'Failed to save settings. Please try again.',
        selectLanguage: 'Select AI output language',

        outputLanguage: {
            title: 'AI Output Language',
            description: 'Choose the language AI uses when responding to your questions and generating content',
        },

        error: {
            title: 'Error',
        },

        info: {
            title: 'How it works:',
            point1: 'AI will respond in your selected language for all conversations',
            point2: 'Settings are synced across all your devices',
            point3: 'Changes take effect immediately for new conversations',
        },
    },
};
